import React, { useState } from 'react';
import { colors, gradients, shadows } from '../../theme/tokens';
import Icon from './Icon';

// The round green action button from the example cards (arrow / chevron).
const IconButton = ({
  icon = 'arrow_forward',
  size = 40,
  iconSize,
  variant = 'primary', // primary | ghost
  title,
  onClick,
  style,
  type = 'button',
  ...rest
}) => {
  const [hover, setHover] = useState(false);

  const base = {
    width: size,
    height: size,
    minWidth: size,
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease',
    transform: hover ? 'translateY(-1px) scale(1.05)' : 'none'
  };

  const variants = {
    primary: {
      background: gradients.button,
      color: colors.white,
      boxShadow: hover ? shadows.glow : shadows.sm
    },
    ghost: {
      background: colors.glassStrong,
      color: colors.text,
      border: `1px solid ${colors.glassBorder}`
    }
  };

  return (
    <button
      type={type}
      title={title}
      aria-label={title}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ ...base, ...variants[variant], ...style }}
      {...rest}
    >
      <Icon name={icon} size={iconSize || Math.round(size * 0.5)} />
    </button>
  );
};

export default IconButton;
